
import { supabase } from "@/integrations/supabase/client";

/**
 * Gets the display name for a user from community_members
 * Uses nickname if available, otherwise uses full_name
 */
export async function getMemberDisplayName(userId: string): Promise<string> {
  try {
    const { data, error } = await supabase
      .from('community_members')
      .select('nickname, full_name')
      .eq('id', userId)
      .single();
      
    if (error) throw error;
    
    if (data) {
      return data.nickname || data.full_name || `User ${userId.substring(0, 6)}`;
    }
    
    return `User ${userId.substring(0, 6)}`;
  } catch (error) {
    console.error('Error fetching member display name:', error);
    return `User ${userId.substring(0, 6)}`;
  }
}

/**
 * Helper function to get a cached member display name from memory
 * Useful for components that need to display many member names efficiently
 */
export function getCachedDisplayName(
  membersMap: Record<string, { nickname?: string | null; full_name: string }>,
  userId: string
): string {
  const member = membersMap[userId];
  if (member) {
    return member.nickname || member.full_name;
  }
  return `User ${userId.substring(0, 6)}`;
}

/**
 * Helper function to ensure the topic author name is displayed correctly
 * When creating new topics, this ensures we use nickname or full_name consistently
 */
export function getAuthorDisplayName(memberData: any): string {
  if (!memberData) return "Anonymous";
  return memberData.nickname || memberData.full_name || "Anonymous";
}
